import request from '@/utils/request'

const interviewURL = {
  Add: '/interview/create',
  List: '/interview/list',
  Detail: '/interview/view',
  Update: '/interview/update',
  UpdateState: '/interview/update-status',
  Delete: '/interview/delete',
  UpdateIsShow: '/interview/update-is-show'
}

// 创建采访
export function createInterview (data) {
  return request({
    url: interviewURL.Add,
    method: 'post',
    data
  })
}

// 采访列表
export function listInterview (data) {
  return request({
    url: interviewURL.List,
    method: 'post',
    data
  })
}

// 采访详情
export function detailInterview (data) {
  return request({
    url: interviewURL.Detail,
    method: 'post',
    data
  })
}

// 更新采访
export function updateInterview (data) {
  return request({
    url: interviewURL.Update,
    method: 'post',
    data
  })
}

// 更新采访状态
export function updateStateInterview (data) {
  return request({
    url: interviewURL.UpdateState,
    method: 'post',
    data
  })
}

// 删除采访
export function deleteInterview (data) {
  return request({
    url: interviewURL.Delete,
    method: 'post',
    data
  })
}

// 采访列表
export function updateInterviewIsShow (data) {
  return request({
    url: interviewURL.UpdateIsShow,
    method: 'post',
    data
  })
}

export default {
  createInterview,
  listInterview,
  detailInterview,
  updateInterview,
  deleteInterview,
  updateStateInterview,
  updateInterviewIsShow
}
